const PREFIX = 'vrm_enc_';

async function getStorage(): Promise<Storage> {
  if (typeof globalThis.localStorage === 'undefined') {
    throw new Error('localStorage unavailable');
  }
  return globalThis.localStorage;
}

export default {
  async getItem(key: string): Promise<string | null> {
    const s = await getStorage();
    return s.getItem(PREFIX + key);
  },
  async setItem(key: string, value: string): Promise<void> {
    const s = await getStorage();
    s.setItem(PREFIX + key, value);
  },
  async removeItem(key: string): Promise<void> {
    const s = await getStorage();
    s.removeItem(PREFIX + key);
  },
};
